<template>
    <div>
        <menu-bar></menu-bar>
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/pontos"><i class="fa fa-suitcase" aria-hidden="true"></i> PONTOS</a></li>
                    <li class="active">CADASTRO DE PONTOS</li>
                </ol>

                <div class="col-md-3">
                    <ponto-menu :ponto_id="ponto_id"></ponto-menu>
                </div>

                <div class="col-md-9" v-if="ponto">
                    <status-ping v-if="ponto.ssh && ponto._id" :ip="ponto.ssh.host"></status-ping>
                    <router-view></router-view>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { PontoMenu } from "../../../components/exports";
import pontoMixin from "../../mixins/pontos";
import pontoComputedMixin from "../../mixins/pontos_computed";
import { StatusPing } from "../../../components/exports";
export default {
    components: { PontoMenu, StatusPing },
    mixins: [pontoMixin, pontoComputedMixin]
};
</script>
